import { productCodeMap } from '@/utils/document/product-code-map';

const path = '/img/products/VOD';

/**
 * BANNER_DATA
 * buttonText 和 buttonLink 一一对应，默认是string，可以是是array；当是array时，渲染多个button
 */
const docConfig = {
  name: '产品文档',
  link: productCodeMap.VOD,
};

export const BANNER_DATA = {
  title: '点播云',
  backgroundImg: `${path}/banner.webp`,
  description:
    '基于数亿级DAU产品实践经验，以点播体验优化为目标，提供集视频上传、存储、分发、播放、数据驱动的体验优化等于一体的精细化点播解决方案型产品，同时，也包含视频分析、画质增强、内容理解等增值能力，为客户提供智能化点播解决方案',
  buttonText: ['申请试用', '客户价值评估工具'],
  buttonLink: ['', `/product/vod-assessment`],
  docText: '产品文档',
  mobileExtraButton: { ...docConfig },
  backgroundImgMobile: `${path}/bannerMobile.webp`,
  links: [
    // { name: 'Demo体验', link: '' },
    { ...docConfig },
    { name: '管理控制台', link: `${process.env.NEXT_PUBLIC_VOD_BASE_URL}/` },
  ],
};
export const ADVANTAGES_EFFECT = [
  {
    title: '内容自适应处理与编码',
    content:
      '基于场景、动作、内容、纹理等对视频进行智能分析、增强/修复处理和自适应转码，联合优化主观画质、降低码率和带宽',
    picUrl: `${path}/icon1.webp`,
  },
  {
    title: '热度触发',
    content:
      '基于视频热度数据统计、分析及预测，确定视频热度分布阈值，进行分级转码决策，最大化实现体验与成本平衡',
    picUrl: `${path}/icon2.webp`,
  },
  {
    title: '融合CDN',
    content:
      '实时筛选和评价CDN质量，结合自建CDN网络，为客户提供最优质量的分发链路，保障终端用户体验的流畅',
    picUrl: `${path}/icon3.webp`,
  },
  {
    title: '极致播放体验优化',
    content: '基于丰富自研组件和全链路体验优化策略，保障用户体验最后一公里',
    picUrl: `${path}/icon4.webp`,
  },
];

export const FEATURES = [
  {
    title: '媒资管理',
    content: '提供统一媒体资产管理服务，包含媒资的存储、媒资信息的管理',
    picUrl: `${path}/icon5.webp`,
  },
  {
    title: '媒体处理',
    content:
      '自研编解码算法、丰富的视频图像基础处理技术、音频处理技术、视频增强与修复技术、视频AI技术等',
    picUrl: `${path}/icon6.webp`,
  },
  {
    title: '分发',
    content: '提供融合CDN的智能调度和分发能力，保障音视频分发速度',
    picUrl: `${path}/icon7.webp`,
  },
  {
    title: '播放',
    content:
      '基于快手网络库、IP优选、预加载策略、高性能解码内核等优势能力，提供播放SDK',
    picUrl: `${path}/icon8.webp`,
  },
];

export const SCENARIO_EFFECT = [
  {
    title: '短视频',
    content:
      '针对短视频场景，提供集采集、生产、上传、媒资管理、媒体处理、分发、播放等环节为一体的短视频 APP 快速搭建方案，并可在各环节提供差异化增值服务',
    picUrl: `${path}/scenario1.webp`,
    picHoverUrl: `${path}/scenario1-hover.webp`,
  },
  {
    title: '长视频',
    content:
      '针对长视频业务，提供场景化能力，如：分片转码、版权保护、HDR、音频增强、视频增强、热度触发、弹幕防挡等',
    picUrl: `${path}/scenario2.webp`,
    picHoverUrl: `${path}/scenario2-hover.webp`,
  },
  {
    title: '直播转点播',
    content:
      '与直播和 RTC 等产品打通，将实时流录制成点播文件，进而在点播链路中进行进一步的剪辑、分发、播放等，实现视频场景的串联，满足全链路视频服务诉求',
    picUrl: `${path}/scenario3.webp`,
    picHoverUrl: `${path}/scenario3-hover.webp`,
  },
];

export const ARCHITECTURE = {
  title: '产品架构',
  picUrl: `${path}/architecture.webp`,
};

export const BRAND = {
  title: '客户案例',
  items: ['快手', 'AcFun', '知乎', '多多视频', '拉拉公园'],
};
